import { CreateDiagnosisReport } from '~/domain/usecases/diagnosisReport/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteCreateDiagnosisReport implements CreateDiagnosisReport {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateDiagnosisReport.Model>;

  constructor(url: string, httClient: HttpClient<CreateDiagnosisReport.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreateDiagnosisReport.Params,
  ): Promise<CreateDiagnosisReport.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
